import { assetTypes, badgeTypes, sellerLevelTypes, tagTypes } from './constants';

const mapTags = (tags: any = []) =>
    tags.map((tag: any) => ({ ...tag, type: tagTypes[tag.type] || tagTypes.TAG_TYPE_UNSPECIFIED }));

const mapAssets = (assets: any = []) =>
    assets.map((asset: any) => ({ ...asset, type: assetTypes[asset.type] || assetTypes.ASSET_TYPE_UNSPECIFIED }));

const mapBadges = (badges: any = []) =>
    badges.map((badge: any) => badgeTypes[badge?.type] || badgeTypes.BADGE_UNSPECIFIED);

const mapSellerLevel = (sellerLevel = 'SELLER_LEVEL_UNSPECIFIED') =>
    sellerLevelTypes[sellerLevel] || sellerLevelTypes.SELLER_LEVEL_UNSPECIFIED;

interface ProfessionCardAttributes {
    profession_id: string;
    seller_profession_id: string;
    shown_title: string;
    shown_title_id: string;
    shown_title_type: string;
    has_intro_video: boolean;
    experience: number;
    algo: string;
    shown_price: number;
    price_usd: number;
    shown_rating: number;
    is_online: boolean;
    badges: any;
    engine: number;
    shown_orders: string;
    number_of_reviews: number;
    assets: any;
    all_tags: any;
    shown_tags: any;
}

export const buildProfessionCardAttributes = (professionCardAttributes: Partial<ProfessionCardAttributes> = {}) => ({
    professionId: professionCardAttributes?.profession_id || '',
    sellerProfessionId: professionCardAttributes?.seller_profession_id || '',
    shownTitle: professionCardAttributes?.shown_title || '',
    shownTitleId: professionCardAttributes?.shown_title_id || '',
    shownTitleType: professionCardAttributes?.shown_title_id || '',
    hasIntroVideo: professionCardAttributes?.has_intro_video || false,
    experience: Number(professionCardAttributes?.experience) || 0,
    algo: professionCardAttributes?.algo || '',
    shownPrice: professionCardAttributes?.shown_price || 0,
    priceUsd: professionCardAttributes?.price_usd || 0,
    shownRating: professionCardAttributes?.shown_rating || 0,
    isOnline: professionCardAttributes?.is_online || false,
    badges: mapBadges(professionCardAttributes?.badges),
    engine: Number(professionCardAttributes?.engine) || 0,
    shownOrders: professionCardAttributes?.shown_orders || '',
    numberOfReviews: professionCardAttributes?.number_of_reviews || 0,
    assets: mapAssets(professionCardAttributes?.assets),
    allTags: mapTags(professionCardAttributes?.all_tags),
    shownTags: mapTags(professionCardAttributes?.shown_tags),
});

interface ProfessionCardSeller {
    id: number;
    country: string;
    is_pro: boolean;
    seller_level: string;
}

export const buildProfessionCardSeller = (seller: Partial<ProfessionCardSeller> = {}) => ({
    id: Number(seller.id),
    country: seller.country || '',
    isPro: seller.is_pro || false,
    sellerLevel: mapSellerLevel(seller.seller_level),
});
